import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/services/shell.service';
import { NgxPermissionsGuard } from 'ngx-permissions';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'users',
      loadChildren: () => import('./users/users.module').then((m) => m.UsersModule),
    },
    {
      path: 'infrastructures',
      loadChildren: () => import('./infrastructures/infrastructures.module').then((m) => m.InfrastructuresModule),
      data: {
        // permissions: {
        //   only: ['Manager', 'Engineer'],
        //   redirectTo: '/not-authorized',
        // },
      },

      // canActivate: [NgxPermissionsGuard],
    },

    {
      path: 'dashboard',
      loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    },

    {
      path: 'not-authorized',
      loadChildren: () =>
        import('./permission-restriction/permission-restriction.module').then((m) => m.PermissionRestrictionModule),
    },
  ]),
  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
